import { router } from "./MyRouter";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ThemeProvider } from "@mui/material";
import moment from "moment";
import "moment/locale/es";
import { createTheme } from "@mui/material/styles";
import { startPqrsdLabel, usePqrsdLabel } from "./components/pqrsd/pqrsdLabel";

const theme = createTheme({
  palette: {
    primary: {
      main: process.env.REACT_APP_THEME,
    },
  },
});

moment.locale("es");

// The PQRSD module's display name (Config → PQRSD → General) follows the live
// config; pages read it through pqrsdText.
startPqrsdLabel();

function App() {
  // Route elements are constants, so a new name only reaches the pages by
  // remounting the router. It changes only when an admin renames the module.
  // (The citizen pages' URL follows the name through /:moduleSlug routes, so
  // the router itself is never rebuilt.)
  const pqrsdLabel = usePqrsdLabel();
  return (
    <Provider store={store}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ThemeProvider theme={theme}>
          <RouterProvider key={pqrsdLabel} router={router} />
        </ThemeProvider>
      </LocalizationProvider>
    </Provider>
  );
}

export default App;
